import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#08080C] flex flex-col items-center justify-center px-8 text-center">
      <XCircle className="w-16 h-16 text-rose-400 mb-4" />
      <h1 className="text-2xl font-bold text-slate-100">Paiement annulé</h1>
      <p className="text-slate-400 mt-1">Votre commande n'a pas été réglée.</p>
      <Button onClick={() => navigate("/")} className="btn-gold rounded-xl mt-6 px-8">Retour au catalogue</Button>
    </div>
  );
}
